import { ICoordinates } from 'types/editor';

const getLineExpression = (
  inP: ICoordinates,
  exP: ICoordinates,
  k: number,
): number => k * (inP.x - exP.x) + exP.y;

export default getLineExpression;
